import { useParams } from "common/components/Form/ParamsContext";
import { getBulkEmailSentService } from "./bulkEmailSentApi";

export default function useBulkEmailSentList() {
  const params = useParams();
  const scope = undefined;
  const editUrl = `${
    Object.values(scope || {}).filter(v => !!v).length > 0
      ? "bulk-emails-sent/"
      : ""
  }`;
  const service = getBulkEmailSentService();

  return { ...service, params, scope, editUrl };
}
